import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTeam } from '../context/TeamContext';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

function AddMemberPage() {
  const [name, setName] = useState('');
  const [qualifications, setQualifications] = useState({
    JimmyJib: false,
    Moving: false,
    Switcher: false,
    Title: false,
    Animasi: false,
    Foto: false,
    Lighting: false,
    Socmed: false
  });
  const [eventPreferences, setEventPreferences] = useState({
    IBR1: false,
    IBR2: false,
    IBR3: false,
    IBR4: false,
    NOW: false,
    WBI: false,
    Wedding: false,
    'Special Events': false
  });
  const [unavailableDates, setUnavailableDates] = useState({});
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [active, setActive] = useState(true);
  const navigate = useNavigate();
  const { addTeamMember } = useTeam();

  const qualificationOrder = ['JimmyJib', 'Moving', 'Switcher', 'Title', 'Animasi', 'Foto', 'Lighting', 'Socmed'];
  const eventOrder = ['IBR1', 'IBR2', 'IBR3', 'IBR4', 'NOW', 'WBI', 'Wedding', 'Special Events'];

  const handleQualificationChange = (event) => {
    setQualifications({
      ...qualifications,
      [event.target.name]: event.target.checked
    });
  };

  const handleEventPreferenceChange = (event) => {
    setEventPreferences({
      ...eventPreferences,
      [event.target.name]: event.target.checked
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const newMember = { name, qualifications, eventPreferences, unavailableDates, active };
    addTeamMember(newMember);
    navigate('/team-members');
  };

  const addUnavailableDate = () => {
    const dateString = selectedDate.toISOString().split('T')[0];
    setUnavailableDates(prev => ({
      ...prev,
      [dateString]: eventOrder.reduce((acc, event) => {
        acc[event] = false;
        return acc;
      }, {})
    }));
  };

  const removeUnavailableDate = (dateToRemove) => {
    setUnavailableDates(prev => {
      const { [dateToRemove]: removed, ...rest } = prev;
      return rest;
    });
  };

  const handleUnavailableEventChange = (date, event, isChecked) => {
    setUnavailableDates(prev => ({
      ...prev,
      [date]: {
        ...prev[date],
        [event]: isChecked
      }
    }));
  };

  const selectAllQualifications = () => {
    const allSelected = {};
    qualificationOrder.forEach(qual => {
      allSelected[qual] = true;
    });
    setQualifications(allSelected);
  };

  const clearAllQualifications = () => {
    const allCleared = {};
    qualificationOrder.forEach(qual => {
      allCleared[qual] = false;
    });
    setQualifications(allCleared);
  };

  const selectAllEvents = () => {
    const allSelected = {};
    eventOrder.forEach(event => {
      allSelected[event] = true;
    });
    setEventPreferences(allSelected);
  };

  const clearAllEvents = () => {
    const allCleared = {};
    eventOrder.forEach(event => {
      allCleared[event] = false;
    });
    setEventPreferences(allCleared);
  };

  return (
    <div className="page-container">
      <h1 className="text-3xl font-bold text-gray-800 text-center mb-8">ADD MEMBER</h1>
      
      <form onSubmit={handleSubmit} className="space-y-8">
        {/* Name input */}
        <div className="space-y-2">
          <label htmlFor="name" className="block text-lg font-semibold text-gray-700">
            Name:
          </label>
          <input
            type="text"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            className="form-input"
            placeholder="Enter member name"
          />
        </div>

        {/* Qualifications section */}
        <div className="space-y-4">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-semibold text-gray-700">Qualifications:</h2>
            <div className="flex gap-2">
              <button
                type="button"
                onClick={selectAllQualifications}
                className="text-sm px-3 py-1 bg-green-500 text-white rounded hover:bg-green-600 transition-colors"
              >
                Select All
              </button>
              <button
                type="button"
                onClick={clearAllQualifications}
                className="text-sm px-3 py-1 bg-gray-500 text-white rounded hover:bg-gray-600 transition-colors"
              >
                Clear All
              </button>
            </div>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
            {qualificationOrder.map((qualification) => (
              <label key={qualification} className="flex items-center space-x-2 cursor-pointer">
                <input
                  type="checkbox"
                  name={qualification}
                  checked={qualifications[qualification]}
                  onChange={handleQualificationChange}
                  className="w-4 h-4 text-primary-500 border-gray-300 rounded focus:ring-primary-500"
                />
                <span className="text-gray-700">{qualification}</span>
              </label>
            ))}
          </div>
        </div>

        {/* Event Preferences section */}
        <div className="space-y-4">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-semibold text-gray-700">Event Preferences:</h2>
            <div className="flex gap-2">
              <button
                type="button"
                onClick={selectAllEvents}
                className="text-sm px-3 py-1 bg-green-500 text-white rounded hover:bg-green-600 transition-colors"
              >
                Select All
              </button>
              <button
                type="button"
                onClick={clearAllEvents}
                className="text-sm px-3 py-1 bg-gray-500 text-white rounded hover:bg-gray-600 transition-colors"
              >
                Clear All
              </button>
            </div>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
            {eventOrder.map((event) => (
              <label key={event} className="flex items-center space-x-2 cursor-pointer">
                <input
                  type="checkbox"
                  name={event}
                  checked={eventPreferences[event]}
                  onChange={handleEventPreferenceChange}
                  className="w-4 h-4 text-primary-500 border-gray-300 rounded focus:ring-primary-500"
                />
                <span className="text-gray-700">{event}</span>
              </label>
            ))}
          </div>
        </div>

        {/* Unavailable Events section */}
        <div className="space-y-4">
          <h2 className="text-xl font-semibold text-gray-700">Unavailable Events:</h2>
          <div className="flex flex-col sm:flex-row gap-4 items-start">
            <div className="flex-shrink-0">
              <DatePicker
                selected={selectedDate}
                onChange={(date) => setSelectedDate(date)}
                className="form-input w-full sm:w-auto"
                dateFormat="yyyy-MM-dd"
                placeholderText="Select date"
              />
            </div>
            <button
              type="button"
              onClick={addUnavailableDate}
              className="btn-primary whitespace-nowrap"
            >
              Add Date
            </button>
          </div>

          {/* Display unavailable dates */}
          {Object.keys(unavailableDates).length > 0 && (
            <div className="space-y-3">
              {Object.entries(unavailableDates).map(([date, events]) => (
                <div key={date} className="bg-gray-50 p-4 rounded-lg">
                  <div className="flex justify-between items-center mb-3">
                    <h3 className="font-semibold text-gray-700">{date}</h3>
                    <button
                      type="button"
                      onClick={() => removeUnavailableDate(date)}
                      className="text-red-500 hover:text-red-700 text-sm"
                    >
                      Remove Date
                    </button>
                  </div>
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2">
                    {eventOrder.map((event) => (
                      <label key={event} className="flex items-center space-x-2 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={events[event] || false}
                          onChange={(e) => handleUnavailableEventChange(date, event, e.target.checked)}
                          className="w-4 h-4 text-red-500 border-gray-300 rounded focus:ring-red-500"
                        />
                        <span className="text-sm text-gray-600">{event}</span>
                      </label>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Active status */}
        <div className="space-y-2">
          <label className="flex items-center space-x-2 cursor-pointer">
            <input
              type="checkbox"
              checked={active}
              onChange={(e) => setActive(e.target.checked)}
              className="w-4 h-4 text-primary-500 border-gray-300 rounded focus:ring-primary-500"
            />
            <span className="text-lg font-semibold text-gray-700">Active Member</span>
          </label>
        </div>

        {/* Submit button */}
        <div className="pt-4">
          <button
            type="submit"
            className="btn-primary w-full py-3 text-lg"
          >
            Add Member
          </button>
        </div>
      </form>
    </div>
  );
}

export default AddMemberPage;